import React from 'react';

const formatTime = (ts) => {
  const d = new Date(ts);
  return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
};

const MessageBubble = ({ message, mine }) => (
  <div className={`flex ${mine ? 'justify-end' : 'justify-start'}`}>
    <div
      className={`max-w-[75%] rounded-2xl ${message.image_base64 ? 'p-1.5' : 'px-4 py-2'} ${
        mine
          ? 'bg-fnl-pink text-white rounded-br-sm'
          : 'bg-fnl-purple-light text-white rounded-bl-sm'
      }`}
    >
      {message.image_base64 && (
        <img
          src={message.image_base64}
          alt="attachment"
          className="rounded-xl max-w-full max-h-72 object-cover cursor-pointer"
          onClick={() => window.open(message.image_base64, '_blank')}
        />
      )}
      {message.content && (
        <div className={`text-sm whitespace-pre-wrap break-words ${message.image_base64 ? 'px-2 pt-1.5' : ''}`}>
          {message.content}
        </div>
      )}
      <div
        className={`text-[10px] ${message.image_base64 ? 'px-2 pb-1' : ''} ${
          mine ? 'text-pink-100' : 'text-purple-300'
        } text-right`}
      >
        {formatTime(message.timestamp)}
      </div>
    </div>
  </div>
);

const MessageList = ({ messages, currentUserId, endRef }) => (
  <div className="flex-1 overflow-y-auto p-5 space-y-3" data-testid="chat-messages-list">
    {messages.length === 0 ? (
      <div className="text-center text-purple-300 text-sm py-10">
        Say hi to start the conversation!
      </div>
    ) : messages.map((m) => (
      <MessageBubble key={m.id} message={m} mine={m.sender_id === currentUserId} />
    ))}
    <div ref={endRef} />
  </div>
);

export default MessageList;
